<template>
  <div id="body">

    <base-navigation />

    <base-card>

      <div id="element-to-convert">

        <!-- HEADER -->
        <div class="row">

          <div class="col-lg-6">
            <img
              width="120"
              height="100"
              src="../../assets/gafwa_logo.png"
            />
          </div>

             <div class="col-lg-6">
            Gusii advocates first welfare 
            <br />
            Benevolent welfare for members
            <br />
           
            gafwa.roberms.com, gafwawelfare@gmail.com

            <!-- {{ memberdetails }} -->
          </div>

        </div>

        <!-- TITLE -->
        <div class="row mt-3">

          <div class="col-lg-7">
            <small><b>Expenses Report</b></small>
          </div>

          <div class="col-lg-5 text-info">
            <small>{{ currentDate }}</small>
          </div>

        </div>

        <br>

        <!-- SUMMARY -->
        <div class="card p-3">

          <h6>Contribution Summary (All Cases)</h6>

          <div class="row">

            <div
              v-for="caseItem in sortedCases"
              :key="caseItem.case_id"
              class="col-lg-3 col-md-4 col-sm-6 mb-2"
            >

              <small>

                Case {{ caseItem.case_id }} :

                <b class="text-danger">
                  {{ getCaseTotal(caseItem.case_id).toLocaleString() }}
                </b>

                <br>

                <i>{{ formatDate(caseItem.payment_date) }}</i>

              </small>

            </div>

          </div>

          <hr>

          <div class="row">

            <div class="col-lg-3">

              <small>
                Registration Total:
                <b class="text-danger">
                  {{ totalRegistration.toLocaleString() }}
                </b>
              </small>

            </div>

            <div class="col-lg-3">

              <small>
                Buffer Total:
                <b class="text-danger">
                  {{ totalBuffer.toLocaleString() }}
                </b>
              </small>

            </div>

            <div class="col-lg-3">

              <small>
                Wallet Total:
                <b class="text-danger">
                  {{ total_walletAmount.toLocaleString() }}
                </b>
              </small>

            </div>

               <div class="col-lg-3">

              <small>
                Case total collection:
                <b class="text-danger">
                  {{ overallTotal.toLocaleString() }}
                </b>
              </small>

            </div>

            <div class="col-lg-3">

              <small>
                Total Expenses:
                <b class="text-danger">
                  {{ total_expense.toLocaleString() }}
                </b>
              </small>

            </div>

            
            <div class="col-lg-3">

              <small>
                Available Funds:
                <b class="text-success">
                  {{
                    (
                      overallTotal +
                      total_walletAmount -
                      total_expense
                    ).toLocaleString()
                  }}
                </b>
              </small>

            </div>

            

            

          </div>

          <!-- <div class="row mt-2">

            <div class="col-lg-6">

              <small>
                Available Funds:
                <b class="text-success">
                  {{
                    (
                      overallTotal +
                      total_walletAmount -
                      total_expense
                    ).toLocaleString()
                  }}
                </b>
              </small>

            </div>

          </div> -->

          <hr>

          <!-- CASE EXPENSES TABLE -->

          <h6>Case Expenses</h6>

          <table class="table myFormat table-bordered table-sm">

            <thead>
              <tr>
                <th>Case</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Reference</th>
                <th>Paid To</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>

              <tr
                v-for="expense in caseExpenses"
                :key="expense.id"
              >

                <td>{{ expense.item }}</td>

                <td>{{ expense.description }}</td>

                <td class="text-danger">
                  {{ expense.amount.toLocaleString() }}
                </td>

                <td>{{ expense.reference }}</td>

                <td>{{ expense.paid_to }}</td>

                <td>{{ formatDate(expense.expense_date) }}</td>

              </tr>

            </tbody>

          </table>


          <!-- OTHER EXPENSES TABLE -->

          <h6 class="mt-4">Other Expenses</h6>

          <table class="table myFormat table-bordered table-sm">

            <thead>
              <tr>
                <th>Item</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Reference</th>
                <th>Paid To</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>

              <tr
                v-for="expense in otherExpenses"
                :key="expense.id"
              >

                <td>{{ expense.item }}</td>

                <td>{{ expense.description }}</td>

                <td class="text-danger">
                  {{ expense.amount.toLocaleString() }}
                </td>

                <td>{{ expense.reference }}</td>

                <td>{{ expense.paid_to }}</td>

                <td>{{ formatDate(expense.expense_date) }}</td>

              </tr>

            </tbody>

          </table>


          <hr>

          <h5 class="text-danger">

            Grand Total Expenses:
            {{ total_expense.toLocaleString() }}

          </h5>

        </div>

      </div>

      <br>

      <button
        class="btn btn-primary"
        @click="exportToPDF"
      >
        Download PDF
      </button>

      <br><br>

      <router-link to="/">
        Go back
      </router-link>

    </base-card>

  </div>
</template>

<script>

import html2pdf from "html2pdf.js";

export default {

  name: "ExpensesReport",

  computed: {

    memberdetails() {

      return this.$store.getters.allMembers || [];

    },

    someMembers() {

      return this.$store.getters.newmembers || [];

    },

    cases() {

      return this.$store.getters.cases || [];

    },

    otherExpensesRaw() {

      return this.$store.getters.expenses || [];

    },

    sortedCases() {

      return [...this.cases]

        .sort(
          (a, b) =>
            new Date(b.payment_date) -
            new Date(a.payment_date)
        );

    },

    caseExpenses() {

      return [...this.cases]

        .sort(
          (a, b) =>
            new Date(b.payment_date) -
            new Date(a.payment_date)
        )

        .map(caseItem => ({

          id: `CASE-${caseItem.case_id}`,

          item: `Case ${caseItem.case_id}`,

          description:
            `Loss of ${caseItem.relationship}`,

          amount:
            Number(caseItem.amount_disbursed) || 0,

          reference:
            `CASE-${caseItem.case_id}`,

          paid_to:
            caseItem.Member_name,

          expense_date:
            caseItem.payment_date

        }));

    },

    otherExpenses() {

      return [...this.otherExpensesRaw]

        .sort(
          (a, b) =>
            new Date(b.expense_date) -
            new Date(a.expense_date)
        )

        .map(exp => ({

          id: `EXP-${exp.id}`,

          item: exp.item,

          description: exp.description,

          amount: Number(exp.amount) || 0,

          reference: exp.reference,

          paid_to: exp.paid_to,

          expense_date: exp.expense_date

        }));

    },

    total_expense() {

      return [

        ...this.caseExpenses,

        ...this.otherExpenses

      ]

      .reduce(
        (acc, item) =>
          acc + item.amount,
        0
      );

    },

    currentDate() {

      return new Date()
        .toLocaleString("nl-NL");

    },

    totalRegistration() {

      return this.sumField(
        "registration_amount"
      );

    },

    totalBuffer() {

      return this.sumField(
        "buffer_amount"
      );

    },

    total_walletAmount() {

      return this.someMembers.reduce(

        (acc, item) =>
          acc +
          parseInt(
            item.wallet_amount || 0
          ),

        0

      );

    },

    overallTotal() {

      let total =
        this.totalRegistration +
        this.totalBuffer;

      this.cases.forEach(c => {

        total += this.getCaseTotal(
          c.case_id
        );

      });

      return total;

    },
       totalCases() {

      let total =
     

      this.cases.forEach(c => {

        total += this.getCaseTotal(
          c.case_id
        );

      });

      return total;

    }

  },

  methods: {

    sumField(field) {

      return this.someMembers.reduce(

        (acc, item) =>
          acc +
          parseInt(item[field] || 0),

        0

      );

    },

    getCaseTotal(caseId) {

      return this.someMembers.reduce(

        (acc, item) =>
          acc +
          parseInt(
            item[`case_${caseId}_amount`] || 0
          ),

        0

      );

    },

    formatDate(date) {

      return date
        ? date.split("T")[0]
        : "";

    },

    exportToPDF() {

      const element =
        document.getElementById(
          "element-to-convert"
        );

      html2pdf(element, {

        margin: [0, 10, 0, 10],

        filename:
          "Expenses_Report_" +
          new Date()
            .toLocaleDateString("nl-NL") +
          ".pdf",

        image: {
          type: "jpeg",
          quality: 0.98
        },

        html2canvas: {
          dpi: 192,
          scale: 2
        },

        jsPDF: {
          unit: "mm",
          format: "a3",
          orientation: "portrait"
        }

      });

    }

  },

  created() {

    this.$store.dispatch("Loadmembers");

    this.$store.dispatch("LoadPayments");

    this.$store.dispatch("LoadNewmembers");

    this.$store.dispatch("LoadCases");

    this.$store.dispatch("LoadExpenses");

  }

};

</script>

<style scoped>

table.myFormat tr td {

  font-size: 12px;

}

</style>
